export const SIGN_UP = "/signup";

export const SIGN_IN = "/signin";

export const HOME = "/";

export const CATEGORY = "/category";

export const PAYMENT = "/payment";

export const FAVORITES = "/favorites";

export const ITEM = "/item";
